module.exports = __webpack_public_path__ + "img/healththink official  logo (2).91f2e613.svg";